/**
 * Papéis do time INTERNO numa negociação.
 *
 * Vive em shared/ porque o rótulo em pt-BR precisa ser o mesmo no funil, na
 * timeline, no relatório e no MCP — três textos diferentes para "sdr" é como a
 * mesma pessoa vira "SDR" numa tela e "Pré-vendas" na outra.
 *
 * Não confundir com `dealParticipantRole` (decisor, influenciador, técnico…),
 * que descreve gente do lado do CLIENTE.
 */

export const DEAL_TEAM_ROLES = [
  "sdr",
  "hunter",
  "closer",
  "pre_vendas",
  "cs",
  "gerente",
  "parceiro",
] as const;

export type DealTeamRole = (typeof DEAL_TEAM_ROLES)[number];

export const DEAL_TEAM_ROLE_LABELS: Record<DealTeamRole, string> = {
  sdr: "SDR",
  hunter: "Hunter",
  closer: "Closer",
  pre_vendas: "Pré-vendas",
  cs: "Customer Success",
  gerente: "Gerente",
  parceiro: "Parceiro",
};

/** Uma linha de ajuda por papel — usada no seletor, para o time não chutar. */
export const DEAL_TEAM_ROLE_HINTS: Record<DealTeamRole, string> = {
  sdr: "Qualifica o lead que chegou e marca a reunião",
  hunter: "Prospecta ativamente e abre a oportunidade",
  closer: "Conduz a reunião e fecha a venda",
  pre_vendas: "Apoia tecnicamente antes da proposta",
  cs: "Cuida do cliente depois da venda",
  gerente: "Acompanha e aprova a negociação",
  parceiro: "Indicou ou participa por fora do time",
};

export function dealTeamRoleLabel(role: string | null | undefined): string {
  if (!role) return "—";
  return DEAL_TEAM_ROLE_LABELS[role as DealTeamRole] ?? role;
}
